import { create } from 'zustand';
import { ApiUtils } from '@shared/utils';
import { CardsApi } from '@shared/api/rest';
import { TopupRequest, TopupResponse } from '@shared/api/rest/cards';
import { RequestStrategyEnum } from '@shared/api/rest/models';

interface TopupType {
  data?: TopupResponse;
  loading: boolean;
  error: string | null;
  post: (request: TopupRequest, cardId: string, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useTopupStore = create<TopupType>((set) => ({
  data: undefined,
  loading: false,
  error: null,

  post: ApiUtils.wrapperApi(async (request, cardId, signal) => {
    try {
      set({ loading: true, error: null });
      const result = await CardsApi.topup(request, cardId, signal);
      set({ data: result?.data ?? [], loading: false });
    } catch (error) {
      set({ error: ApiUtils.getApiError(error), loading: false });
      throw error;
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ data: undefined, loading: false, error: null }),
}));
